<template>
    <SidebarWrapper>
      <div class="h-full max-h-full overflow-hidden">
        <Scrollbar class="w-full h-full max-h-screen">
          <div v-show="!categories.loaded" class="block xl:hidden">
            <div class="w-full mt-8 px-2">
              <CategoryLoader />
            </div>
          </div>
          <ErrorMessage v-show="!categories.loading && categories.error && categories.error?.message" :message="categories.error?.message" />
          <div v-show="categories.loaded && !categories.error && !categories.error?.message" class="py-3 px-6">
            <CatalogueSearchFilter v-if="isCataloguePage" />
            <Search v-else :label="$t('text-search-label')" variant="minimal" />
            <template v-if="isCataloguePage">
              <SidebarMenu
                v-if="!isCatalogueIndex || !hasSingleCatalogueCategory"
                :type="CATEGORY_TYPE.CATALOGUE"
                :items="categories[CATEGORY_TYPE.CATALOGUE]"
                :is-detail="true"
              />
              <FilterCatalogueParameters :is-detail="true" class="pb-8" />
            </template>
            <template v-else>
              <div v-if="!isSearchPage || search.variants?.items?.length">
                <h2 class="pt-8 pb-1 mb-5 text-2xl font-bold text-heading border-b border-primary-neutral">
                  {{ $t('text-ads') }}
                </h2>
                <SidebarMenu type="" :items="categories[CATEGORY_TYPE.ESHOP]" :show-my="true" :is-detail="true" class="pb-8" />
                <LocationFilter class="mb-5" :is-detail="true" />
                <FilterCategoryParameters :is-detail="true" />
                <WatchdogAddBtn :is-detail="true" />
              </div>
              <div v-if="!isSearchPage || search.news?.items?.length">
                <h2 class="pt-8 pb-1 mb-5 text-2xl font-bold text-heading border-b border-primary-neutral">
                  {{ $t('text-posts') }}
                </h2>
                <SidebarMenu :type="CATEGORY_TYPE.NEWS" :items="categories[CATEGORY_TYPE.NEWS]" :show-all="isSearchPage && !search.variants?.items?.length" />
                <FilterContentParameters :type="CATEGORY_TYPE.NEWS" :is-detail="true" class="pb-8" />
              </div>
              <div v-if="!isSearchPage || search.inspiration?.items?.length">
                <h2 class="pt-8 pb-1 mb-5 text-2xl font-bold text-heading border-b border-primary-neutral">
                  {{ $t('text-inspiration') }}
                </h2>
                <SidebarMenu :type="CATEGORY_TYPE.CONTENT" :items="categories[CATEGORY_TYPE.CONTENT]" :show-all="isSearchPage && !search.variants?.items?.length && !search.news?.items?.length" class="pb-8" />
              </div>
              <div v-if="isSearchPage && search.catalogue?.items?.length">
                <h2 class="pt-8 pb-1 mb-5 text-2xl font-bold text-heading border-b border-primary-neutral">
                  {{ $t('text-catalogue') }}
                </h2>
                <SidebarMenu :type="CATEGORY_TYPE.CATALOGUE" :items="categories[CATEGORY_TYPE.CATALOGUE]" :show-all="!search.variants?.items?.length && !search.news?.items?.length && !search.inspiration?.items?.length" />
                <FilterCatalogueParameters :is-detail="true" class="pb-8" />
              </div>
            </template>
          </div>
        </Scrollbar>
      </div>
    </SidebarWrapper>
</template>

<script setup>
import { CATEGORY_TYPE } from "@utils/constants";
import { ROUTES } from "@utils/routes";
import { useCategoryStore } from '@stores/category';
import { useSearchStore } from '@stores/search';
import SidebarWrapper from "@components/common/sidebar/sidebar-wrapper";
import CategoryLoader from "@components/ui/loaders/category-loader";
import ErrorMessage from "@components/ui/error-message";
import Scrollbar from "@components/ui/scrollbar";
import Search from "@components/common/search";
import SidebarMenu from "@components/ui/sidebar-menu";
import LocationFilter from "@components/filter/location-filter";
import FilterContentParameters from "@components/filter/filter-content-parameters";
import FilterCategoryParameters from "@components/filter/filter-category-parameters";
import FilterCatalogueParameters from "@components/filter/filter-catalogue-parameters";
import CatalogueSearchFilter from "@components/catalogue/catalogue-search-filter";
import WatchdogAddBtn from "@components/watchdog/watchdog-add-btn";

const categories = useCategoryStore();
const search = useSearchStore();
const route = useRoute();
const isSearchPage = computed(() => route.path === translatePath(ROUTES.CODE.SEARCH));

const routeName = computed(() => route?.name || '');
const isCataloguePage = computed(() => routeName.value.startsWith('catalogue___') || routeName.value.startsWith('catalogue-type-slug___'));
const isCatalogueIndex = computed(() => routeName.value.startsWith('catalogue___'));
const hasSingleCatalogueCategory = computed(() => categories[CATEGORY_TYPE.CATALOGUE]?.length === 1);

</script>
